import { takeLatest, fork, all } from 'redux-saga/effects';
import formActionSaga from 'redux-form-saga';

import * as types from 'misc/types';
import { checkStatus } from './status_check';
import { authenticate, logout, refreshSession } from './sessions';
import { getCustomer, postCustomer, putCustomer, deleteCustomer } from './customer';
import { getTexts } from './texts';
import { getMedias } from './medias';
import { getTags } from './tags';
import { getAgreement, putAgreement } from './agreement';
import { getEnvelopes } from './envelopes';
import { archiveEnvelope, deleteEnvelope } from './envelope';
import { getEnvelopeContents } from './envelope_contents';
import { getEnvelopeContentBody } from './envelope_content_body';
import { searchArchives } from './search_results';
import { postSupport } from './support.js';
import { getGovernmentConnect, postGovernmentConnect, deleteGovernmentConnect, getGovernmentList, putGovernmentList } from './government';
import { getCompanyList } from './company';
import { getVerifications } from './verifications';

// main saga generators
export function* sagas() {
    yield all([
        fork(takeLatest, types.SAGA_STATUS_CHECK.REQUEST, checkStatus),

        fork(takeLatest, types.SAGA_LOGIN.REQUEST, authenticate),
        fork(takeLatest, types.SAGA_SESSION_GET.REQUEST, refreshSession),
        fork(takeLatest, types.SAGA_LOGOUT.REQUEST, logout),

        fork(takeLatest, types.SAGA_CUSTOMER_GET.REQUEST, getCustomer),
        fork(takeLatest, types.SAGA_CUSTOMER_POST.REQUEST, postCustomer),
        fork(takeLatest, types.SAGA_CUSTOMER_PUT.REQUEST, putCustomer),
        fork(takeLatest, types.SAGA_CUSTOMER_DELETE.REQUEST, deleteCustomer),

        fork(takeLatest, types.SAGA_TEXTS_GET.REQUEST, getTexts),
        fork(takeLatest, types.SAGA_MEDIAS_GET.REQUEST, getMedias),
        fork(takeLatest, types.SAGA_TAGS_GET.REQUEST, getTags),

        fork(takeLatest, types.SAGA_GOVERNMENT_CONNECT_GET.REQUEST, getGovernmentConnect),
        fork(takeLatest, types.SAGA_GOVERNMENT_CONNECT_POST.REQUEST, postGovernmentConnect),
        fork(takeLatest, types.SAGA_GOVERNMENT_CONNECT_DELETE.REQUEST, deleteGovernmentConnect),
        fork(takeLatest, types.SAGA_GOVERNMENT_LIST_GET.REQUEST, getGovernmentList),
        fork(takeLatest, types.SAGA_GOVERNMENT_LIST_PUT.REQUEST, putGovernmentList),

        fork(takeLatest, types.SAGA_COMPANY_GET.REQUEST, getCompanyList),

        fork(takeLatest, types.SAGA_AGREEMENT_GET.REQUEST, getAgreement),
        fork(takeLatest, types.SAGA_AGREEMENT_PUT.REQUEST, putAgreement),

        fork(takeLatest, types.SAGA_ENVELOPES_INBOX_GET.REQUEST, getEnvelopes),
        fork(takeLatest, types.SAGA_ENVELOPES_ARCHIVES_GET.REQUEST, getEnvelopes),

        fork(takeLatest, types.SAGA_ENVELOPE_CONTENTS_GET.REQUEST, getEnvelopeContents),
        fork(takeLatest, types.SAGA_ENVELOPE_CONTENT_INLINE_GET.REQUEST, getEnvelopeContentBody),
        fork(takeLatest, types.SAGA_ENVELOPE_CONTENT_DOCUMENT_GET.REQUEST, getEnvelopeContentBody),

        fork(takeLatest, types.SAGA_ENVELOPE_ARCHIVE.REQUEST, archiveEnvelope),
        fork(takeLatest, types.SAGA_ENVELOPE_DELETE.REQUEST, deleteEnvelope),

        fork(takeLatest, types.SAGA_ARCHIVES_SEARCH_GET.REQUEST, searchArchives),

        fork(takeLatest, types.SAGA_SUPPORT_POST.REQUEST, postSupport),
        fork(takeLatest, types.SAGA_VERIFICATIONS.REQUEST, getVerifications),

        fork(formActionSaga)
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js